import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { NavbarButton } from '../components/Layout/NavbarButton';
import { iconButtonStyle } from '../utils/styles';
import { shortcutLabel } from '../shared/keyboard';
import { useUndoRedo } from './useUndoRedo';

// Boutons annuler/rétablir de la navbar + raccourcis clavier (montés via le
// hook). Même style que les autres boutons navbar (NavbarButton + iconButtonStyle).
// Même comportement que Cmd/Ctrl+Z (cf. useUndoRedo), raccourci affiché selon le système. Désactivés pendant
// l'aperçu PDF, ou quand il n'y a rien à annuler hors édition de texte.
export const UndoRedoButtons = () => {
  const { canUndo, canRedo, pressUndo, pressRedo } = useUndoRedo();

  return (
    <>
      <NavbarButton
        tooltipContent={`Annuler (${shortcutLabel('Mod+Z')})`}
        disabled={!canUndo}
        onClick={pressUndo}
        icon={
          <FontAwesomeIcon
            icon={icon({ name: 'rotate-left', family: 'duotone', style: 'solid' })}
            style={iconButtonStyle()}
          />
        }
      />
      <NavbarButton
        tooltipContent={`Rétablir (${shortcutLabel('Mod+Maj+Z')})`}
        disabled={!canRedo}
        onClick={pressRedo}
        icon={
          <FontAwesomeIcon
            icon={icon({ name: 'rotate-right', family: 'duotone', style: 'solid' })}
            style={iconButtonStyle()}
          />
        }
      />
    </>
  );
};

export default UndoRedoButtons;
